module.exports = __webpack_public_path__ + "img/idcard-back.92005c95.png";